
import { HelpCircle } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

interface PageTitleProps {
  title: string;
  description?: string;
  tutorialSteps?: string[];
}

export const PageTitle = ({
  title,
  description,
  tutorialSteps,
}: PageTitleProps) => {
  return (
    <div className="flex items-start justify-between">
      <div className="flex flex-col space-y-2">
        <h1 className="font-bold tracking-tight text-xl">{title}</h1>
        {description && <p className="text-muted-foreground">{description}</p>}
      </div>

      {tutorialSteps && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <button className="p-1.5 hover:bg-primary/10 rounded-full transition-colors">
                <HelpCircle className="h-5 w-5 text-primary hover:text-primary/80" />
              </button>
            </TooltipTrigger>
            <TooltipContent align="end" className="max-w-xs p-4">
              <div className="space-y-2">
                <p className="font-medium">Comment utiliser {title.toLowerCase()} :</p>
                <ul className="text-sm space-y-1">
                  {tutorialSteps.map((step, index) => (
                    <li key={index} className="flex items-center gap-2">
                      <span className="text-xs bg-primary/20 rounded-full w-5 h-5 flex items-center justify-center">
                        {index + 1}
                      </span>
                      {step}
                    </li>
                  ))}
                </ul>
              </div>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
    </div>
  );
};
